import React from "react";

export default Component =>
  class extends React.Component {
    componentDidMount() {
      this.props.onLoad();
    }

    componentWillReceiveProps(nextProps) {
      if (!this.props.loading && nextProps.loading) {
        this.props.onLoad();
      }
    }

    render() {
      return <Component {...this.props} />;
    }
  };



// WEBPACK FOOTER //
// ./src/sc/ui/components/hoc/componentWithLoadTrigger.js